import { CategoryScale, Chart as ChartJS, Legend, BarElement, LinearScale, PointElement, Title, Tooltip } from 'chart.js';
import classNames from 'classnames';
import { useRef, useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import styles from './style.module.scss';
import { CaretIcon } from 'assets';
import { useSelector } from 'react-redux';
import DropDownOptions from 'shared/components/common/dropdown/dropdown_option/DropdownOption';
import { optionsDateRange } from 'shared/utils/IntegrationConstant';
import { dateRangesEnum, themeEnum } from 'shared/utils/Enum';
import { startOfDay, endOfDay, subDays, startOfWeek, subMonths, startOfMonth, subQuarters, startOfQuarter, subYears, startOfYear } from 'date-fns';
import moment from 'moment';

const CustomBarChart = ({ name, ChartWraper, labels, data1, data2 }) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const dropdownRef = useRef();
    ChartJS.register(CategoryScale, LinearScale, PointElement, BarElement, Title, Tooltip, Legend);

    // Default data if not provided
    const defaultLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const defaultData1 = [0, 0, 0, 0, 0, 0, 0];
    const defaultData2 = [0, 0, 0, 0, 0, 0, 0];

    const finalLabels = labels && labels.length > 0 ? labels : defaultLabels;
    const finalData1 = data1 && data1.length > 0 ? data1 : defaultData1;
    const finalData2 = data2 && data2.length > 0 ? data2 : defaultData2;

    const [loading, setLoading] = useState(false);
    const [openSelection, setOpenSelection] = useState(false);
    const [dateRange, setDateRange] = useState('This Week');

    useEffect(() => {
        ChartJS.defaults.color = themeEnum.Light === theme ? '#5B5B5B' : 'white';
    }, [theme]);

    const premiumOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                backgroundColor: 'rgba(0,0,0,0.8)',
                padding: 10,
                cornerRadius: 6,
                displayColors: false
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                    drawBorder: false
                },
                ticks: {
                    font: { size: 11 },
                    color: '#9ca3af'
                }
            },
            y: {
                grid: {
                    borderDash: [5, 5],
                    color: 'rgba(0,0,0,0.05)',
                    drawBorder: false
                },
                ticks: {
                    display: false
                },
                border: { display: false }
            }
        },
        interaction: {
            mode: 'index',
            intersect: false,
        },
        barThickness: 12,
        borderRadius: 6
    };

    return (
        <div className={classNames(styles.chartContainer, ChartWraper && ChartWraper, `${theme}SummaryContainer`, 'py-4 px-3 d-flex flex-column gap-3')}>
            <div className={classNames('d-flex w-100 justify-content-between align-items-center  px-3')}>
                <label className={classNames(styles.chartTitle, `${theme}FontColor`)}>{name}</label>
                {/* Kept Dropdown for visual consistency, though functionality needs parent callback */}
                <div
                    className={classNames('d-flex align-items-center justify-content-center gap-2 position-relative')}
                    role={'button'}
                >
                    <label className={classNames(styles.dateLabel, `${theme}FontColor`)} role="button">
                        {dateRange}
                    </label>
                </div>
            </div>
            <div style={{ flex: 1, minHeight: 0 }}>
                <Bar
                    options={premiumOptions}
                    data={{
                        labels: finalLabels,
                        datasets: [
                            {
                                label: 'Current',
                                data: finalData1,
                                backgroundColor: '#10b981',
                                borderRadius: 6,
                                barPercentage: 0.6,
                            },
                            {
                                label: 'Previous',
                                data: finalData2,
                                backgroundColor: '#e5e7eb',
                                borderRadius: 6,
                                barPercentage: 0.6,
                                hidden: !data2 // Hide if no data2 provided
                            }
                        ]
                    }}
                />
            </div>
        </div>
    );
};

export default CustomBarChart;

